<template>
  <div style="max-width: 750px;margin: auto">
    <div
      v-if="!showContent"
      style="width: 100%;height: 100vh;background-color: #ffffff;position:relative;"
    >
      <div
        style="display: block;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;"
      >
        <img src="../../assets/loading.gif" alt="" />
        <span
          style="position: relative;z-index: 1;display: inline-block;margin-top:-77px;font-size: 14px;"
          >页面正在加载中，请稍候</span
        >
      </div>
    </div>
    <!--    <div v-if="showNoHcp" style="width: 100%;height: 100vh;background-color: #333;position:fixed;z-index:9999;left:0;right:0;bottom:0;top:0;opacity: 0.5">-->
    <!--      <div style="display: block;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;">-->
    <!--&lt;!&ndash;        <img src="../../assets/loading.gif" alt="">&ndash;&gt;-->
    <!--        <span style="position: relative;z-index: 1;display: inline-block;margin-top:-77px;font-size: 14px;">该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- <div v-show="!showContent && showQRcode" style="position: fixed;left: 0;right: 0;top: 0;bottom:0;;display: flex;justify-content: center;align-items: center" >
      <div style="text-align: center">
        <p>关注“吾医空间”完成签到</p>
        <p style="margin: 10px 0;text-align: center">
          <span class="f_w">前沿咨询、线上展会、品牌学院，</span><br><span>属于你的学术成长空间！</span>
        </p>
        <img id="topImg" v-if="imgUrl" :src="imgUrl" width="70%" alt="">
        <p style="margin: 10px 0">长按识别二维码并关注</p>
      </div>
    </div> -->
    <!-- <div v-if="showGuide" class="guideTofollow"></div> -->
    <!-- 解决由于跳转/api/wechat/oauth2/authorize链接（网络慢的情况下），导致无法进去register页面加载loading效果 -->
    <!-- <div v-if="false">
      <iframe
        :src="iframeUrl"
        frameborder="0"
        style="width: 100%;"
        scrolling="auto"
      ></iframe>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      baseUrl: process.env.config.baseUrl,
      ymtSsoUrl: process.env.config.ymtSsoUrl,
      hostUrl: process.env.config.seviceUrl + "/ymtLogin",

      redirectUrl: this.$route.query.redirectUrl || "",
      docCode: this.$route.query.docCode || "",
      openId: this.$route.query.openId || "",
      meetingemscode: this.$route.query.meetingemscode || "",
      needRegisterData: this.$route.query.needRegisterData || "",
      showContent: false,
      postData: {
        openId: "",
        docName: "",
        docCode: "",
        province: "",
        city: "",
        instName: "",
        department: "",
        fieldIds: [],
        indications: [],
        wuJiaMeetingId: "",
        isOce: false,
        hcpType: "",
        meetingemscode: "",
      },
    };
  },
  mounted() {
    document.title = "授权注册中";
    this.ymtLogin();
  },
  methods: {
    ymtLogin() {
      debugger
      // tip点击医脉通注册
      var self = this
      if (this.$route.query.toLogin==='true') {
        // tip拼接认证url
        var returnUrl = encodeURIComponent(
          this.hostUrl + "?toLogin=false"
          + "&docCode=" + this.docCode
          + "&openId=" + this.openId
          + "&meetingemscode=" + this.meetingemscode
          + "&needRegisterData=" + this.needRegisterData
          + "&redirectUrl=" + encodeURIComponent(this.redirectUrl)
        );
        console.log('ymtUrl',this.ymtSsoUrl +
          "?client_id=" +
          process.env.config.ymtClientId +
          "&redirect_uri=" +
          returnUrl)
        window.location.href =
          this.ymtSsoUrl +
          "?client_id=" +
          process.env.config.ymtClientId +
          "&redirect_uri=" +
          returnUrl;
      } else {
        debugger
        // tip获得授权，访问api取用户信息   
        var param = {
          ymtCode:this.$route.query.code
        }
        console.log('param',param)
        this.$axiox.post("/Login/YmtRegister", param).then(p => {
          if (p.isSuccess) {

            self.postData.docName = p.data.name;
            self.postData.province = p.data.province;
            self.postData.city = p.data.city;
            self.postData.instName = p.data.hospital;
            self.postData.department = p.data.department;
            self.postData.fieldIds = p.data.interest_field.indexOf('未匹配')>=0?'':p.data.interest_field.split(",");
            self.postData.indications = p.data.interest_indications.indexOf('未匹配')>=0?'':p.data.interest_indications.split(",");
            self.register(self.postData);
          }
        });
      }
    },
    register(data) {
      debugger
      var self = this
      let tempDoccode = "";
      if (
        this.$route.query.docCode &&
        this.$route.query.docCode !== "undefined" &&
        this.$route.query.docCode !== undefined
      ) {
        tempDoccode = this.$route.query.docCode;
      }
      var fieldArr=[],indications = [];

      if(data.fieldIds!==''){
        data.fieldIds.forEach(x=>{fieldArr.push(+x)});
      }
      if(data.indications!==''){
        data.indications.forEach(x=>{indications.push(+x)});
      }

      let postData = {
        openId: this.openId,
        docName: data.docName,
        docCode: this.docCode,
        province: data.province,
        city: data.city,
        instName: data.instName,
        department: data.department,
        fieldIds: fieldArr,
        indications: indications,
        wuJiaMeetingId: "",
        isOce: this.docCode ? true : false,
        hcptype:this.meetingemscode ? 5 : "",
        meetingemscode:this.meetingemscode,
        fromYmt:true
      };
      this.$axiox.post("/Login/Register", postData).then(p => {
            if (self.redirectUrl) {
              this.$commonJs.showTips('注册成功，稍后将为您跳转！')
              setTimeout(p => {
                if (self.needRegisterData && self.needRegisterData == "true") {
                  let registerData = {
                    docName: data.docName,
                    province: data.province,
                    instName: data.instName,
                    selfInstName: data.instName,
                    hcpType: data.hcpType,
                    city: data.city,
                    openId: self.openId
                  };
                  window.location.href = this.$commonJs.returnQuery2(
                    self.redirectUrl,
                    registerData
                  );
                } else {
                  let registerData = {
                    openId: self.openId
                  };
                  window.location.href = this.$commonJs.returnQuery2(
                    self.redirectUrl,
                    registerData
                  );
                }
              }, 2000);
            }
            else{
              this.$commonJs.showTips('注册成功')
              window.setTimeout(t => {
                this.$commonJs.closeWindow()
              }, 2000)
            }
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/ymtLogin.vue